import { encode as base64_encode, decode as base64_decode } from "base-64";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";
import utf8 from "utf8";
import Cookies from "js-cookie";

class StudentStore {
    StudentListArray = [];
    getClass = [];
    total = 0;
    loading = false;
    triplist = [];
    areawiseStudentList = [];
    schoolTripList = [];

    rootStore;

    constructor(rootStore) {
        makeObservable(this, {
            StudentListArray: observable,
            getClass: observable,
            areawiseStudentList: observable,
            schoolTripList: observable,
            total: observable,
            loading: observable,
            triplist: observable,
            loadData: action,
            getAllClass: action,
            getVehicles: action,
            loadTripData: action,
            getAreawiseStudents: action,
            getSchooltrip: action,
            assignBus: action,
            sampleExcel: action,
            // setPhotoFromDb: action,
            setPhotoFromDbstud: action,
            setPhotoFromDbparent1: action,
            setPhotoFromDbparent2: action,

        });
        this.rootStore = rootStore;
    }

    async addData(postData) {
        const data = {
            AddPassenger: postData,
        }
        console.log("*************StudentStore*****************", data)
        const base64Input = await base64_encode(utf8.encode(JSON.stringify(data)));
        var response = await postApi
            .getClient()
            .post("index.php?c=student&a=update", "postData=" + base64Input);
        return response.data;
    }

    async loadData({ companyId, offset, limit, searchField, subscribe }) {
        this.loading = true;
        var postData = { companyId: companyId, offset: offset, limit: limit, searchField: searchField, subscribe: subscribe };
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient()
            .post("index.php?c=student&a=studentlist", "postData=" + base64Input);
        // console.log(response?.data)
        this.StudentListArray = response?.data?.data?.passdetails;
        this.total = parseInt(response?.data?.data?.TotalCount);
        this.loading = false;
    }

    async getStudentData(passengerId) {
        this.loading = true;
        var postData = { passengerId: passengerId, offset: 0, limit: 1, };
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient()
            .post("index.php?c=student&a=studentlist", "postData=" + base64Input);
        console.log(response?.data)
        const singleRow = response?.data?.data?.passdetails[0];


        if (singleRow.photo) {
            const fileList = [
                {
                    name: singleRow.photo,
                    status: "success",
                    url: config.fleetURL + "/images/students/" + singleRow.photo,
                },
            ];

            await this.setPhotoFromDbstud(fileList);
        }


        if (singleRow.parentPhoto1) {
            const fileList = [
                {
                    name: singleRow.parentPhoto1,
                    status: "success",
                    url: config.fleetURL + "/images/students/" + singleRow.parentPhoto1,
                },
            ];

            await this.setPhotoFromDbparent1(fileList);
        }


        if (singleRow.parentPhoto2) {
            const fileList = [
                {
                    name: singleRow.parentPhoto2,
                    status: "success",
                    url: config.fleetURL + "/images/students/" + singleRow.parentPhoto2,
                },
            ];

            await this.setPhotoFromDbparent2(fileList);
        }
        this.loading = false;

        return singleRow;
    }

    async getVehicles(companyId, tripId) {
        // {"tokenId":"","companyId":"409","userId":2997,"isadmin":"1","offset":0,"limit":100}
        var postData = {
            companyId: companyId,
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
            offset: 0,
            limit: 100,
            stId: tripId
        };
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient()
            // .post("index.php?c=vehicle&a=getVehicleDetail", "postData=" + base64Input);
            .post("index.php?c=student&a=getVehicleDetail", "postData=" + base64Input);
        console.log(response, "post");

        this.assetVehicleList = response?.data?.data;
        return response?.data?.data;
    }

    async getAllClass() {
        // console.log("vehicle list")
        var postData = null;
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient()
            .post(
                "index.php?c=notification&a=getAllClass",
                "postData=" + base64Input
            );
        console.log(response?.data?.data, "post")
        this.getClass = response?.data?.data;
        return response?.data?.data;
    }
    async loadTripData(companyId, offset, limit) {
        var postData = {
            companyId: companyId,
            offset: offset,
            limit: limit
        };
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient()
            .post("index.php?c=trip&a=masterTripDetails", "postData=" + base64Input);
        console.log(response, "post");

        this.triplist = response?.data?.data;
        return response?.data?.data;
    }
    async getAreawiseStudents(data) {
        const base64Input = base64_encode(JSON.stringify(data));
        const response = await postApi
            .getClient()
            .post("index.php?c=student&a=getAreawiseStudents", "postData=" + base64Input);

        this.areawiseStudentList = response?.data?.data?.studentDetails || [];
        return response?.data?.data;
    }

    async getSchooltrip(companyId) {
        var postData = {
            companyId: companyId, offset: 0, limit: 50, page: 1
        };
        const base64Input = base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient()
            .post("index.php?c=student&a=getSchoolTrip", "postData=" + base64Input);
        this.schoolTripList = response?.data?.data?.schoolTrips || [];
        return response;
    }
    async assignBus(data) {
        console.log(data)
        const base64Input = base64_encode(JSON.stringify(data));
        var response = await postApi
            .getClient()
            .post("index.php?c=student&a=saveVehicleTripDetails", "postData=" + base64Input);
        return response?.data;
    }
    async assignStudent(data) {
        console.log(data)
        const base64Input = base64_encode(JSON.stringify(data));
        var response = await postApi
            .getClient()
            .post("index.php?c=student&a=assignStudentTrip", "postData=" + base64Input);
        return response;
    }

    async deleteRecord(passengerId) {
        var postData = { passengerId: passengerId };
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient()
            .post("index.php?c=student&a=delete", "postData=" + base64Input);
        return response;
    }

    async sampleExcel() {
        window.location.href = config.fleetURL + "/appRes/Student.xlsx";
    }

    async setPhotoFromDbstud(photo) {
        console.log(photo);
        this.photoFromDb = { fileList: photo };
    }
    async setPhotoFromDbparent1(photo) {
        console.log(photo);
        this.photoFromDbparent1 = { fileList: photo };
    }
    async setPhotoFromDbparent2(photo) {
        console.log(photo);
        this.photoFromDbparent2 = { fileList: photo };
    }


}

export default StudentStore;
